import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["onClick", "onKeydown"]

import { computed } from "vue";
import { TableDataCellDisplayType } from "@/models/etc/types";
import type { CellDataIdList, TableDataCell } from "@/models/interfaces/entity-settings/querytable/querytable";
import { i18n } from "@/i18n";

interface SourceLink { ids: number[]; name: string; type: number; }


export default /*@__PURE__*/_defineComponent({
  __name: 'SourceItemsCellElementLite',
  props: {
    element: {}
  },
  emits: ["sourceItemsRequested"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const t = (k: string) => i18n.global.t(k);

const elementUrls = computed<SourceLink[]>(() => {
  const isSourceItem = props.element.DisplayType === TableDataCellDisplayType.IdList;
  if (!isSourceItem) return [];
  const res = (props.element.Data as CellDataIdList[]).map((cell) => ({
    ids: cell.IdList,
    type: cell.IdListEntityType,
    name: t("elements") + ": " + cell.IdList.length,
  }));
  // нет исходных элементов - пустая строка (прочерк оставляем только у параметров)
  return res.length ? res : [{ ids: [], name: "", type: 0 }];
});

function onLinkClick(ids: number[], type: number) {
  emit("sourceItemsRequested", { ids, type });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elementUrls.value, (link, i) => {
    return (_openBlock(), _createElementBlock("span", {
      key: i,
      class: "qtl-source-link",
      role: "link",
      tabindex: "0",
      onClick: _withModifiers(($event: any) => (onLinkClick(link.ids, link.type)), ["stop"]),
      onKeydown: _withKeys(_withModifiers(($event: any) => (onLinkClick(link.ids, link.type)), ["stop"]), ["enter"])
    }, _toDisplayString(link.name), 41, _hoisted_1))
  }), 128))
}
}

})